import { useEffect, useRef, useState } from "react";
import InvoiceHeader from "../../../../../../../assets/images/Invoice-Hader.png";
// import InvoiceFooter from '../../../../../../assets/images/Invoice-Footer.png'
import InvoiceFooter from "../../../../../../../assets/images/Invoice-Footer.png";
import { Table } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import "./MarketplaceInvoiceBng.css";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { Markup } from "interweave";

export default function MarketplaceOrderInvoiceBng() {
  const pdfExportComponent = useRef(null);
  const handleButtonClick = (event) => {
    pdfExportComponent.current.save();
  };

  const pdfExportComponentBng = useRef(null);
  const handleButtonClickBng = (event) => {
    pdfExportComponentBng.current.save();
  };

  const { id } = useParams();

  const [orderView, setOrderListView] = useState("");

  useEffect(() => {
    axios
      .get(`/api/admin/marketplace/order/product-list/view/${id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setOrderListView(res.data.orderListView);
        }
      });
  }, []);

  return (
    <>
      <PDFExport ref={pdfExportComponentBng} paperSize="A3">
        <div className="parentInvoiceBng d-flex justify-content-center">
          <div className="containerInvoiceBng">
            <div>
              <img
                src={InvoiceHeader}
                alt=""
                height="160px"
                className="w-100"
              />
            </div>
            <div className="d-flex justify-content-end">
              <div className="my-3">
                <p className="fontTextBng">অর্ডার আই ডি : #{orderView?.order_no}</p>
                <p className="fontTextBng">
                  অর্ডার তারিখ : {moment(orderView?.created_at).format("LL")}{" "}
                  {moment(orderView?.created_at).format("LT")}
                </p>
              </div>
            </div>
            <div className="viewMarginBng starAndViewBng">
              <div className="">
                <h4 className="sueprStarHeaderTitleBng">HelloSuperstars.com</h4>
                <p className="fontTextBng">ঠিকান: Dhaka, Bangladesh</p>
                <p className="fontTextBng">ইমেল: joti@gmail.com</p>
                <p className="fontTextBng">ফোন: 01635431430</p>
              </div>
              <div className="">
                <div>
                  <h4 className="sueprStarHeaderTitleBng">
                    {orderView.user?.first_name} {orderView.user?.last_name}
                  </h4>
                  <p className="fontTextBng">
                    {orderView?.area}, {orderView.city?.name}, <br />{" "}
                    {orderView.state?.name},{orderView.country?.name}
                  </p>
                  <p className="fontTextBng">ঠিকান: {orderView.user?.email}</p>
                  <p className="fontTextBng">ফোন: {orderView?.phone}</p>
                  <p className="fontTextBng">ডেলিভারি দেশ: {orderView?.deliverycharge?.country}</p>
                  <p className="fontTextBng">ডেলিভারি কোম্পানী: {orderView?.deliverycharge?.courier_company}</p>
                </div>
              </div>
            </div>
            <div className="tableContainer">
              <Table striped bordered hover>
                <thead className="tableHeadBng">
                  <tr>
                    <td><p className="fontTextBng">পন্যের নাম</p></td>
                    <td> <p className="fontTextBng">সুপারস্টারের নাম</p></td>
                    <td className="fontTextBng"><p>পরিমাণ</p></td>
                    <td className="fontTextBng"><p>একক মূল্য </p></td>
                    <td className="fontTextBng"><p>মোট টাকা</p></td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="fontTextBng">{orderView.marketplace?.title}</td>
                    <td className="fontTextBng">
                      {orderView.star?.first_name} {orderView.star?.last_name}
                    </td>
                    <td className="fontTextBng">{orderView?.items}</td>
                    <td className="fontTextBng">$ {orderView?.unit_price}</td>
                    <td className="fontTextBng">
                      $ {orderView?.items * orderView?.unit_price}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>

            <div className="grandTotalDivBng">
              <div className="starAndViewBng shippingCostDivBng">
                <div className="mx-4">
                  <p className="fontTextBng">মোট : </p>
                  <p className="fontTextBng">ডেলিভারি খরচ : </p>
                  <p className="fontTextBng">মোট কর : </p>
                </div>
                <div className="">
                  <p className="fontTextBng">
                    $ {orderView?.items * orderView?.unit_price}
                  </p>
                  <p className="fontTextBng">$ {orderView?.deliverycharge?.courier_charge}</p>
                  <p className="fontTextBng">$ {orderView?.tax}</p>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <div className="underLineTotalBng"></div>
            </div>
            <div className="d-flex justify-content-end">
              <div className="starAndViewBng">
                <div className="my-2 mx-4">
                  <p>সর্বমোট : </p>
                </div>
                <div className="my-2">
                  <p>${orderView?.total_price}</p>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center">
              <h2 className="">পণ্যটি μয় করার জন্য আপনাকে ধন্যবাদ</h2>
            </div>

            <div className="paymentInfoMarginBng">
              <h5 className="sueprStarHeaderTitleBng">পেমেন্টের তথ্য</h5>
              <p className="fontTextBng">হিসাব/ আই ডি : {orderView?.card_no} </p>
              <p className="fontTextBng">হিসাবের নাম: {orderView?.holder_name} </p>
              <p className="fontTextBng">পেমেন্টের স্থিতি: Paid</p>
            </div>

            <div className="starAndViewBng">
              <div className="">
                <div className="paymentInfoMarginBng">
                  {" "}
                  <h5 className="sueprStarHeaderTitleBng"> শর্ত প্রযোজ্য </h5>
                  <p className="fontTextBng">
                    <Markup content={orderView.marketplace?.terms_conditions} />
                  </p>
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <div>
                  <div className="underLineBng"></div>
                  <h5 className="mt-2">কর্তৃপক্ষের স্বাক্ষর</h5>
                </div>
              </div>
            </div>

            <div>
              <img src={InvoiceFooter} alt="" className="w-100" />
            </div>

            <div></div>
          </div>
        </div>
      </PDFExport>

      <div className="d-flex justify-content-center my-4">
        <Button primary={true} onClick={handleButtonClickBng}>
          Download Pdf
        </Button>
      </div>

    </>
  );
}
